import { useL10n } from "@ews/react-localization-context";
import { countries, countryTranslationsKeyTemplate } from "../../../setup/countries/countries";
import { globalDebounceTime } from "../../../setup/locale";
import TypeAhead from "../../TypeAhead/TypeAheadString";
import { SettingsTypeAheadProps } from "./types";
import { Item } from "../../TypeAhead/types";
import { useCallback, useMemo } from "react";

export function SettingsLanguageTypeAhead<T extends Record<string, any> = Record<string, any>>({
    disabled,
    required,
    value,
    id,
    onChange
}: SettingsTypeAheadProps<T>)
{

    const { translate: t } = useL10n();
    const _countries = useMemo(() => JSON.parse(JSON.stringify(countries)) as typeof countries, []);


    const getTranslation = useCallback((country: string) =>
    {
        return t(countryTranslationsKeyTemplate(country.toLocaleUpperCase()));
    }, [t]);

    return <TypeAhead
        useOffsetY
        disabled={disabled}
        required={required}
        id={id ? id : "LanguageTypeAhead"}
        text={t("PLG_USER_PROFILE_FIELD_COUNTRY_LABEL")}
        debounce={globalDebounceTime}
        value={value ? getTranslation(`${value}`) : undefined}
        onChange={onChange}
        onFilter={function (value: string): Promise<Item<any>[] | undefined>
        {

            return new Promise(resolve =>
            {
                const filteredCountries = _countries.filter(country =>
                    getTranslation(country.alpha3)
                        .toLocaleLowerCase()
                        .includes(
                            value.toLocaleLowerCase()
                        ))
                    .map(country => ({
                        key: "label",
                        data: { label: getTranslation(country.alpha3), alpha3: country.alpha3 }
                    }));

                const reset = { key: "label", data: { label: "-------", alpha3: undefined } };

                resolve([reset, ...filteredCountries]);
            });
        }} />;
};
